<p-dialog
  data-testid="stock-selection-dialog"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '1200px', maxWidth: '95vw' }"
  [header]="getDialogHeader()"
  (onHide)="onCancel()"
>
  <div class="flex flex-col h-full">
    <!-- Search and Filter Section -->
    <div class="flex-shrink-0 px-4 py-2">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        @for (field of searchFields; track field.key) {
          <div class="space-y-2">
            <label class="block text-sm font-medium text-gray-700">
              {{ field.label | translate }}
            </label>
            <input
              [attr.data-testid]="'stock-selection-dialog-search-input-' + field.key"
              pInputText
              [(ngModel)]="searchForm()[field.key]"
              [placeholder]="field.placeholder | translate"
              class="w-full"
            />
          </div>
        }
      </div>
      <div class="flex gap-2 mt-3 mb-1">
        <app-button
          [testId]="'stock-selection-dialog-search-btn'"
          [label]="'common.actions.search' | translate"
          [type]="'info'"
          (emitOnClick)="onSearch()"
        ></app-button>
        <app-button
          [testId]="'stock-selection-dialog-reset-btn'"
          [label]="'common.actions.reset' | translate"
          [type]="'secondary'"
          [outlined]="true"
          (emitOnClick)="onSearchReset()"
        ></app-button>
      </div>
    </div>

    <!-- Stock Items Table -->
    <div class="mb-4">
      <app-data-table
        data-testid="stock-selection-dialog-table"
        [dataSource]="stockItems()"
        [columns]="tableColumns"
        [loading]="loading()"
        [totalRecords]="totalRecords()"
        [rows]="pageSize()"
        [first]="(currentPage() - 1) * pageSize()"
        [selection]="selectedItems()"
        (selectionChange)="onSelectionChange($event)"
        [hasCheckColumn]="true"
        [hasHeaderCheckbox]="true"
        [hasSerialColumn]="false"
        [isRowSelectedFn]="getSelectionState.bind(this)"
        [isRowDisabledFn]="isRowDisabled.bind(this)"
        (pageChange)="onPageChange($event)"
        [scrollHeight]="'500px'"
        class="w-full"
      />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <!-- Cancel button -->
      <app-button
        [testId]="'stock-selection-dialog-cancel-btn'"
        label="common.actions.cancel"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
        [disabled]="loading()"
      ></app-button>

      <!-- Confirm button -->
      <app-button
        [testId]="'stock-selection-dialog-confirm-btn'"
        label="common.actions.confirm"
        type="info"
        (emitOnClick)="onConfirm()"
        [disabled]="loading() || selectedItems().length === 0"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Toast Messages -->
<p-toast data-testid="stock-selection-dialog-toast"></p-toast>
